import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import comm from "csi/comm";
import def from "csi/def";
import { Field } from "csi/def/Field";
import { writeFormFields } from "csi/service/writerService";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import apparel from "./main";


const PromoteToTheme = declare([Controller, ActionControllerMixin], {
	fdStylePage: null,
	fdThemeFormPage: null,
	fdColorwaysPage: null,
	fdStyleBOMsPage: null,
	fdDocumentsPage: null,
	LINK_TO_STYLE: "PromoteToTheme_LinkToStyle",
	THEMEMASTER_NODE_NAME: "ThemeMaster/Node Name",
	THEMEMASTER_SUBTYPE: "ThemeMaster/Subtype",
	THEME_SEASONS: "ThemeSeasons",
	bShowWait: true,
	fromStyle: null,
	isFromThemeAction: false,

	/** @override
	 * Set the fromStyle and isPromoteAction to the viewParams for ThemeForm on Promote and New Theme From Style
	 */
	onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view, viewParams) {
		const index = wizard.getIndexOfPage(page);
		if ((index == 0 && !this.isFromThemeAction) || (index == 1 && this.isFromThemeAction)) {
			viewParams.isPromoteAction = true;
		}
	},

	/**
	*@override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		let fd: FormData = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		if (!this.isFromThemeAction) {
			if (indexOfPage == 0) {
				fd = this.fdThemeFormPage = this.fdThemeFormPage || new FormData(this);
				this.fromStyle = this.getNode();
			} else if (indexOfPage == 1) {
				fd = this.fdColorwaysPage = this.fdColorwaysPage || new FormData(this);
			} else if (indexOfPage == 2) {
				fd = this.fdStyleBOMsPage = this.fdStyleBOMsPage || new FormData(this);
			} else if (indexOfPage == 3) {
				fd = this.fdDocumentsPage = this.fdDocumentsPage || new FormData(this);
			}
		} else {
			if (indexOfPage == 0) {
				fd = this.fdStylePage = this.fdStylePage || new FormData(this);
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			} else if (indexOfPage == 1) {
				this.fromStyle = wizard.getFormDataFromPage(currentPage)
					.getSelectedNode();
				fd = this.fdThemeFormPage = this.fdThemeFormPage || new FormData(this);
			} else if (indexOfPage == 2) {
				fd = this.fdColorwaysPage = this.fdColorwaysPage || new FormData(this);
			} else if (indexOfPage == 3) {
				fd = this.fdStyleBOMsPage = this.fdStyleBOMsPage || new FormData(this);
			} else if (indexOfPage == 4) {
				fd = this.fdDocumentsPage = this.fdDocumentsPage || new FormData(this);
			}
			if (indexOfPage !== 0) {
				fd.setNode(this.fromStyle);
			}
		}
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, (wizard.getIndexOfPage(nextPage) == 1)): null;
	},

	/**
	 * @override
	 * Disable Previous button on index 1 if the action is New Theme From Style
	 */
	disablePrev: function(wizard, page, index) {
		// prevent user from going back to first step of wizard by clicking on wizard card
		if (this.isFromThemeAction && index) {
			const selectStyleCard = wizard._getStepCardByIndex(0);
			selectStyleCard.setInactive(true);
			selectStyleCard.selectStep = function(): void {
				//do nothing
			};
		}
		return !index || (this.isFromThemeAction && index == 1);
	},

	/**
	 * @override
	 */
	toWriter: function () {
		const { fdThemeFormPage, LINK_TO_STYLE, THEMEMASTER_NODE_NAME, THEMEMASTER_SUBTYPE, THEME_SEASONS } = this;
		const linkToStyle = fdThemeFormPage.getFieldValue(LINK_TO_STYLE);
		const themeMasterName = fdThemeFormPage.getFieldValue(THEMEMASTER_NODE_NAME);
		const themeName = fdThemeFormPage.getFieldValue(xml.ATTR_NAME);
		const subtype = fdThemeFormPage.getFieldValue(THEMEMASTER_SUBTYPE);
		const themeSeasons = fdThemeFormPage.getFieldValue(THEME_SEASONS);
		const styleUrl = this.fromStyle.$URL;
		const themeSecurityGroupUrl = this.getParent().$Type === "ThemeSecurityGroup" ? this.getParent().$URL : null;
		this.m_urlNode = comm.createUrl();
		const defaultFields = [LINK_TO_STYLE, THEMEMASTER_NODE_NAME, xml.ATTR_NAME, THEMEMASTER_SUBTYPE, THEME_SEASONS];
		const customFields = fdThemeFormPage.getFields()
			.filter((field: Field) => !defaultFields.includes(field.getControlName()) && field.m_typeControl !== def.FIELD_COMMENT);

		const { m_writer: writer, m_urlNode } = this;	

		const call = writer.callMethod("MaterialSpec", themeSecurityGroupUrl === null ? "PromoteStyleToTheme" : "PromoteStyleToThemeUnderTSG")
			.addParameter("URL", xml.ATTR_CNL, m_urlNode)
			.addParameter("LinkToStyle", xml.ATTR_BOOLEAN, linkToStyle)
			.addParameter("ThemeMasterName", xml.ATTR_STRING, themeMasterName)
			.addParameter("ThemeName", xml.ATTR_STRING, themeName)
			.addParameter("Subtype", xml.ATTR_REF, subtype);
		// Handles Single Season subtype for season field
		if (typeof(themeSeasons) === "string") {
			call.addParameter("ThemeSeasons", xml.ATTR_REFLIST, [themeSeasons]);
		} else {
			call.addParameter("ThemeSeasons", xml.ATTR_REFLIST, themeSeasons);
		}
		call.addParameter("FromStyle", xml.ATTR_STRING, styleUrl)
			.addParameter("Colorways", xml.ATTR_REFLIST, this.fdColorwaysPage.getSelectedValue())
			.addParameter("StyleBOMs", xml.ATTR_REFLIST, this.fdStyleBOMsPage.getSelectedValue())
			.addParameter("Documents", xml.ATTR_REFLIST, this.fdDocumentsPage.getSelectedValue());

		if (themeSecurityGroupUrl !== null){
			call.addParameter("ThemeSecurityGroup", xml.ATTR_STRING, themeSecurityGroupUrl);
		}
			
		writeFormFields(writer, m_urlNode, customFields);

		this.setProgress();
	},

	postProcessSuccess: function() {
		// summary: refresh view when done if not already 
		if (this.fdThemeFormPage.getFieldValue(this.LINK_TO_STYLE)) {
			apparel.refreshChildViewIfExists("BOMs");
			apparel.refreshChildViewIfExists("DataSheetIndex");
		}
		this.inherited(arguments);
	},
});

export = PromoteToTheme;